import React, {useEffect, useState, useRef} from 'react';
import HomeSidebar from './../homeSidebar/homeSidebar';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import {PostIcon} from '../SvgIcons/SvgIcons';
import BountyCard from './BountyCard';
import {Modal} from 'antd';
import PostBounty from './PostBounty';
import IntroCard from './IntroCard';
import {BOUNTIES_COUNT, MY_BOUNTIES} from './../../../graphql/query/bounties';
import {gql, useLazyQuery, useMutation} from '@apollo/client';
import {useSelector} from 'react-redux';
import {removeDuplicates} from './../../../utils/helpers/reusableFuntions';
import {Spin} from 'antd';
import {RESET_MY_INTROS_COUNT} from './../../../graphql/mutations/offers';
import {
  GET_MY_INTROS,
  INTROS_COUNT,
  MY_INTROS_COUNT,
} from '../../../graphql/query/offers';
import CustomSelect from '../../CustomSelect';
import IntroSelect from '../../IntroSelect';

const MyBounties = () => {
  const [start, setStart] = useState(0);
  const [limit, setLimit] = useState(10);
  const [myBounties, setMyBounties] = useState([]);
  const [introCount, setIntroCount] = useState(0);
  const [rendering, setRendering] = useState(true);
  const [isNextRequest, setIsNextRequest] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [filter, setFilter] = useState('active');
  const [page, setPage] = useState(1);
  const loader = useRef(null);
  const [myIntros, setMyIntros] = useState([]);
  const [bountiesCount, setBountiesCount] = useState(0);
  const [checkAll, setCheckAll] = useState(false);
  const [checkActive, setCheckActive] = useState(true);
  const [checkCompleted, setCheckCompleted] = useState(false);
  const [introFilter, setIntroFilter] = useState('active');
  const [introAll, setIntroAll] = useState(false);
  const [introActive, setIntroActive] = useState(true);
  const [introCompleted, setIntroCompleted] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [renderingIntros, setRenderingIntros] = useState(true);
  const [isNextRequestIntros, setIsNextRequestIntros] = useState(true);
  const [hasMoreIntros, setHasMoreIntros] = useState(true);
  const [startIntros, setStartIntros] = useState(0);
  const [pageRendring, setPageRendering] = useState(1);
  const loaderIntros = useRef(null);
  const [countIntro, setCountIntro] = useState(0);

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
  }, []);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPage((page) => page + 1);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (isNextRequest) {
      setStart(start + 10);
      setIsNextRequest(false);
      getMyBounties({
        variables: {
          profileId: userProfile.id,
          status: filter,
          start: start + 10,
          limit,
        },
      });
    }
  }, [page]);

  useEffect(() => {
    if (isNextRequestIntros) {
      setStartIntros(startIntros + 10);
      setIsNextRequestIntros(false);
      getMyIntros({
        variables: {
          profileId: userProfile.id,
          status: introFilter,
          start: startIntros + 10,
          limit: 10,
        },
      });
    }
  }, [pageRendring]);

  const [getMyBounties, { data: myBountiesList }] =
    useLazyQuery(gql(MY_BOUNTIES), {
      fetchPolicy: 'cache-and-network',
    });

  const [myIntrosCount] = useLazyQuery(gql(MY_INTROS_COUNT), {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({offersConnection}) =>
      setIntroCount(offersConnection.aggregate.count),
  });

  const [introCountQuery] = useLazyQuery(gql(INTROS_COUNT), {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({myIntrosCount}) => setCountIntro(myIntrosCount.count),
  });

  useEffect(() => {
    introCountQuery({
      variables: {
        profileId: userProfile.id,
        status: introFilter,
      },
    });
  }, [introFilter]);

  const [myIntrosClearCount] = useMutation(gql(RESET_MY_INTROS_COUNT));

  const userProfile = useSelector((state) => state.strapiRes);
  // debugger
  useEffect(() => {
    if (!myBounties.length && rendering) {
      setRendering(false);
      getMyBounties({
        variables: {profileId: userProfile.id, status: filter, start, limit},
      });
    }
  }, []);

  useEffect(() => {
    if (myBountiesList && myBountiesList.myBounties) {
      setIsNextRequest(true);
      if (myBountiesList.myBounties.length) {
        if (myBountiesList.myBounties.length < 10) setHasMore(false);
        let mergeBounties = [...myBounties, ...myBountiesList.myBounties];
        const result = removeDuplicates(mergeBounties);
        setMyBounties(
          result.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at),
          ),
        );
      } else {
        setHasMore(false);
      }
    }
  }, [myBountiesList]);

  useEffect(() => {
    myIntrosCount({
      variables: {
        introPerson: userProfile.id,
      },
    });
  }, []);

  const clearCount = () => {
    myIntrosClearCount({
      variables: {
        profileId: userProfile.id,
      },
    }).then((res) => {});
  };

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserverIntros, options);
    if (loaderIntros.current) {
      observer.observe(loaderIntros.current);
    }
  }, []);

  const handleObserverIntros = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPageRendering((pageRendring) => pageRendring + 1);
    }
  };

  const [getMyIntros, {data: myIntrosList}] = useLazyQuery(gql(GET_MY_INTROS), {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!myIntros.length && renderingIntros) {
      setRenderingIntros(false);
      getMyIntros({
        variables: {
          profileId: userProfile?.id,
          status: introFilter,
          start: startIntros,
          limit: 10,
        },
      });
    }
  }, []);

  useEffect(() => {
    if (myIntrosList && myIntrosList.getMyIntros) {
      setIsNextRequestIntros(true);
      if (myIntrosList.getMyIntros.length) {
        if (myIntrosList.getMyIntros.length < 10) setHasMoreIntros(false);
        // debugger
        let mergeBounties = [...myIntros, ...myIntrosList.getMyIntros];
        // const result = removeDuplicates(mergeBounties);
        setMyIntros(
          mergeBounties.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at),
          ),
        );
      } else {
        setHasMoreIntros(false);
      }
    }
  }, [myIntrosList]);

  const [bountiesCountQuery] = useLazyQuery(gql(BOUNTIES_COUNT), {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({countTotalBounties}) =>
      setBountiesCount(countTotalBounties.count),
  });

  useEffect(() => {
    bountiesCountQuery({
      variables: {
        profileId: userProfile?.id,
        status: filter,
      },
    });
  }, [filter]);

  const handleGetMyBounties = () => {
    setStart(0);
    getMyBounties({
      variables: {
        profileId: userProfile.id,
        status: filter,
        start: 0,
        limit: 10,
      },
    });
  };

  const handleGetMyIntro = () => {
    setStartIntros(0);
    getMyIntros({
      variables: {
        profileId: userProfile?.id,
        status: introFilter,
        start: 0,
        limit: 10,
      },
    });
  };

  const handleCheckAll = () => {
    setStart(0);
    setIsNextRequest(false);
    setCheckAll(true);
    setFilter('');
    setCheckActive(false);
    setCheckCompleted(false);
    setMyBounties([]);
  };
  const handleCheckActive = () => {
    setStart(0);
    setIsNextRequest(false);
    setCheckActive(true);
    setFilter('active');
    setCheckAll(false);
    setCheckCompleted(false);
    setMyBounties([]);
  };
  const handleCheckCompleted = () => {
    setStart(0);
    setIsNextRequest(false);

    setCheckCompleted(true);
    setFilter('completed');
    setCheckAll(false);
    setCheckActive(false);
    setMyBounties([]);
  };

  const handleIntroAll = () => {
    setStartIntros(0);
    setIsNextRequestIntros(false);
    setIntroAll(true);
    setIntroFilter('');
    setIntroActive(false);
    setIntroCompleted(false);
    setMyIntros([]);
  };

  const handleIntroActive = () => {
    setStartIntros(0);
    setIsNextRequestIntros(false);
    setIntroAll(false);
    setIntroFilter('active');
    setIntroActive(true);
    setIntroCompleted(false);
    setMyIntros([]);
  };

  const handleIntroCompleted = () => {
    setStartIntros(0);
    setIsNextRequestIntros(false);
    setIntroAll(false);
    setIntroFilter('completed');
    setIntroActive(false);
    setIntroCompleted(true);
    setMyIntros([]);
  };

  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={false}
        className="modal-body">
        <PostBounty
          handleCancel={() => {
            setIsModalVisible(false);
          }}
        />
      </Modal>
      <div className="home-content bounty-content">
        <div className="bounty-top">
          <div>
            <h2 className="small-heading">Want to expand your network?</h2>
            <p>Post a bounty and make it happen!</p>
          </div>
          <button className="btn-style" onClick={showModal}>
            <PostIcon />
            Post a bounty
          </button>
        </div>
        <div className="bounty-tabs">
          <Tabs
            defaultActiveKey="mybounties"
            transition={false}
            onSelect={(eventKey) => {
              if (eventKey === 'myintro') {
                clearCount();
              }
            }}>
            <Tab eventKey="mybounties" title="My bounties">
              {myBounties.length ? null : (
                <p>You have not posted any bounty.</p>
              )}

              <div className={myBounties.length ? "active-btn-row" : "active-btn-row justify-content-end"}>
                {myBounties?.length ?
                  (filter === 'completed' ? (
                    <p>{bountiesCount} Completed bounty</p>
                  ) : (
                    <p>{bountiesCount} bounties posted.</p>
                  )): null}
                <CustomSelect
                  filter={filter}
                  handleCheckAll={handleCheckAll}
                  handleCheckActive={handleCheckActive}
                  handleCheckCompleted={handleCheckCompleted}
                  handleGetMyBounties={handleGetMyBounties}
                  checkAll={checkAll}
                  checkActive={checkActive}
                  checkCompleted={checkCompleted}
                />
              </div>
              <div className="bounty-feeds-container">
                {myBounties && myBounties.length ? (
                  myBounties.map((myBounty, index) => {
                    return <BountyCard key={index} myBounty={myBounty} />;
                  })
                ) : (
                  <></>
                )}
                {hasMore && (
                  <div className="loading" ref={loader}>
                    <Spin spinning={loader} className="spin-loading" />
                  </div>
                )}
              </div>
            </Tab>
            <Tab
              eventKey="myintro"
              title={
                <div className="intros-tab">
                  My Intros
                  {introCount !== 0 && (
                    <div className="badges">{introCount}</div>
                  )}
                </div>
              }>
              {myIntros.length ? null : <p>You have not posted any intro.</p>}

              <div className={myIntros?.length ? "active-btn-row" : "active-btn-row justify-content-end"}>
                {myIntros?.length ? <p>{countIntro} Active bounties.</p> : null}
                <IntroSelect
                  handleGetMyIntro={handleGetMyIntro}
                  handleIntroAll={handleIntroAll}
                  handleIntroActive={handleIntroActive}
                  handleIntroCompleted={handleIntroCompleted}
                  introFilter={introFilter}
                  introAll={introAll}
                  introActive={introActive}
                  introCompleted={introCompleted}
                />
              </div>
              <div className="bounty-feeds-container">
                {myIntros && myIntros.length ? (
                  myIntros.map((intro, index) => {
                    return <IntroCard intro={intro} key={index} />;
                  })
                ) : (
                  <></>
                )}
                {hasMoreIntros && (
                  <div className="loading" ref={loaderIntros}>
                    <Spin spinning={loaderIntros} className="spin-loading" />
                  </div>
                )}
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default MyBounties;
